// AddItem adds a new item to the basket.
// In case the item is out of stock or has not enough quantity, the new basket state is returned
// If the item is already present in the basket the qty will be increased.
export const BasketService_AddItemLazy = () =>
  import("./service.grpc").then((m) => m.BasketService_AddItem);
BasketService_AddItemLazy.method =
  "aysa_api.services.basket.v1.BasketService/AddItem" as const;

// Get reduced basket data.
export const BasketService_GetMinimalStateLazy = () =>
  import("./service.grpc").then((m) => m.BasketService_GetMinimalState);
BasketService_GetMinimalStateLazy.method =
  "aysa_api.services.basket.v1.BasketService/GetMinimalState" as const;

// Used to be called from GRIPS in order to ensure that all items have the same coins promotion applied.
// This is used in case a customer goes to checkout as a guest and has to login which merges the basket with the logged in user basket.
export const BasketService_MergeCoinsPromotionLazy = () =>
  import("./service.grpc").then((m) => m.BasketService_MergeCoinsPromotion);
BasketService_MergeCoinsPromotionLazy.method =
  "aysa_api.services.basket.v1.BasketService/MergeCoinsPromotion" as const;

// Used to be called from GRIPS in order to unassign the coins promotion from the basket items.
// This is a temporary workaround for the issue in CO until we have a proper fix on CO side.
export const BasketService_UnassignCoinsPromotionLazy = () =>
  import("./service.grpc").then((m) => m.BasketService_UnassignCoinsPromotion);
BasketService_UnassignCoinsPromotionLazy.method =
  "aysa_api.services.basket.v1.BasketService/UnassignCoinsPromotion" as const;
